import { useState } from "react";
import { SlotsPlatform, FishingPlatform, LiveCasinoPlatform } from "../Pages/casino/CasinoList";
import referenceProviders from "./referenceProviders.json";
import { NavLink } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import UnavailableFeatureDialog from "./UnavailableFeatureDialog";

const items = [
  ["/", "Home", "হোম", "header-home"],
  ["/rng", "Slots", "স্লট", "header-rng"],
  ["/live", "Live", "লাইভ", "header-live"],
  ["/fish", "Fish", "ফিশ", "header-fish"],
  ["/pvp", "Poker", "পোকার", "header-pvp"],
  ["/sports", "Sports", "স্পোর্টস", "header-sports"],
  ["/esports", "E-Sports", "ই-স্পোর্টস", "header-esports"],
  ["/cockfight", "Cockfight", "ককফাইট", "header-cockfight"],
  ["/promotions", "Promotion", "প্রমোশন", "header-promo"],
  ["/down", "App Download", "অ্যাপ ডাউনলোড", "header-app"],
];

const providerGroups = { Slots: "RNG", Fish: "FISH", Live: "LIVE", Poker: "PVP", Sports: "SPORTS" };
const ownProviders = { Slots: SlotsPlatform, Fish: FishingPlatform, Live: LiveCasinoPlatform };
const providerKeys = { JL: "JILI", SPB: "SPRIBE", SG: "SPADE", FS: "FASTSPIN", JK: "JOKER", EG4: "EVO", SEX: "SEXYBCRT", VIA: "VIACASINO", DG: "DREAMGAMING" };
const categoryRoutes = { Slots: "/rng", Fish: "/fish", Live: "/live", Poker: "/pvp", Sports: "/sports", "E-Sports": "/esports", Cockfight: "/cockfight" };
function providerRoute(category, provider) {
  const key = providerKeys[provider.code] || provider.code;
  const match = ownProviders[category]?.find(item => item.key === key);
  return match ? `${categoryRoutes[category]}?type=${encodeURIComponent(match.key)}` : categoryRoutes[category];
}

export default function PrimaryNavigation() {
  const [openMenu, setOpenMenu] = useState(null);
  const [unavailableFeature, setUnavailableFeature] = useState(null);
  const lang = useContextSelector(AuthContext, (ctx) => ctx.lang);
  return (
    <nav className="reference-navigation" aria-label="Main navigation" onMouseLeave={() => setOpenMenu(null)} onBlur={(event) => { if (!event.currentTarget.contains(event.relatedTarget)) setOpenMenu(null); }} onKeyDown={(event) => { if (event.key === "Escape") setOpenMenu(null); }}>
      {items.map(([to, label, bangla, icon]) => to === null ? (
        <span key={label} className="reference-navigation-item" aria-disabled="true"><img src={`/assets/bdtwin/nav-${icon.replace("header-", "")}.png`} alt="" /><span>{lang === "en" ? label : bangla}</span></span>
      ) : (
        <NavLink key={to} to={to} end={to === "/"} onMouseEnter={() => setOpenMenu(providerGroups[label] ? label : null)} onFocus={() => setOpenMenu(providerGroups[label] ? label : null)} onClick={() => setOpenMenu(null)}>
          <img src={`/assets/bdtwin/nav-${icon.replace("header-", "")}.png`} alt="" />
          <span>{lang === "en" ? label : bangla}</span>
        </NavLink>
      ))}
      {openMenu && (
        <div className="reference-provider-menu" aria-label={`${openMenu} providers`}>
          <div className={`reference-provider-menu-grid ${referenceProviders[providerGroups[openMenu]]?.length > 6 ? "no-center" : ""}`}>
            {referenceProviders[providerGroups[openMenu]]?.map(provider => (
              <NavLink key={provider.code} to={providerRoute(openMenu, provider)} className="reference-provider-card" onClick={(event) => { const key = providerKeys[provider.code] || provider.code; if (openMenu !== "Sports" && !ownProviders[openMenu]?.some(item => item.key === key)) { event.preventDefault(); setUnavailableFeature(`${provider.name} ${openMenu}`); } setOpenMenu(null); }}>
                <img className="provider-character" src={provider.image} alt="" />
                <span className="reference-provider-name">{provider.name}</span>
                <span className="reference-provider-action">{lang === "en" ? "BETTING" : "খেলুন"}</span>
              </NavLink>
            ))}
            {["Slots", "Fish", "Live"].includes(openMenu) && <NavLink className="reference-provider-card reference-provider-more" to={categoryRoutes[openMenu]} onClick={() => setOpenMenu(null)}><img src="/assets/bdtwin/menu-more.png" alt="" /><span className="reference-provider-name">{lang === "en" ? "More" : "আরও"}</span></NavLink>}
          </div>
        </div>
      )}
      {unavailableFeature && <UnavailableFeatureDialog feature={unavailableFeature} onClose={() => setUnavailableFeature(null)} />}
    </nav>
  );
}
